const GRAMS_PER_KG = 1000;
const DECIMAL_EXTRACTOR = 1000;

export const getKilogramsAndGramsFromGrams = (value, decimalExtractor = DECIMAL_EXTRACTOR) => {
  const kilograms = value || value === 0 ? Math.floor(value / GRAMS_PER_KG) : value;
  const grams = value || value === 0 ? Math.floor((value % GRAMS_PER_KG) * decimalExtractor) / decimalExtractor : value;
  return {
    kilograms,
    grams,
  };
};

export const combineKilogramsAndGrams = (kilograms = 0, grams = 0) => Math.max(kilograms * GRAMS_PER_KG + grams, 0);
